module.exports = __webpack_public_path__ + "static/media/gb.5db9fea0.svg";